<template>
    <d-container fluid class="main-content-container px-4">
        <d-row>
            <d-col lg="12" class="mx-auto mt-4">
                <h3 class="page-title">Billing</h3>
                <d-card class="card-small edit-user-details mb-4">
                    <d-card-header class="border-bottom">
                        <h5>Billing Information</h5>
                        <d-row class="d-flex justify-content-center">
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title">1. Select monthly billing plan</h6>
                            </d-col>
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title">2. Billing address</h6>
                            </d-col>
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title"><u>3. Payment method</u></h6>
                            </d-col>
                        </d-row>
                        <d-progress :value="percent" :max="100" />
                    </d-card-header>
                    <d-card-body class="p-0">
                        <d-form class="py-4">
                            <div class="p-4">
                                <d-card>
                                    <d-card-body>
                                        <d-col class="form-group">
                                            <label for="upgrade">Your upgrade</label>
                                            <d-form-select required v-model="selectedBillingUpgrade">
                                                <option v-for="item in billingInfo.planApplyingOptions" :value="item.name">{{ item.description }}</option>
                                            </d-form-select>
                                        </d-col>
                                        <d-col class="form-group">
                                            <label for="payment">Payment method</label>
                                            <d-form-select required v-model="selectedPaymentMethod">
                                                <option v-for="item in paymentMethods" :value="item">{{ item.name }}</option>
                                            </d-form-select>
                                            <d-checkbox
                                                v-if="selectedPaymentMethod"
                                                key="confirm"
                                                name="confirm"
                                                class="mt-3"
                                                v-model="confirm"
                                            >
                                                I have read and accept the processing of my monthly recurring payment as described in <a href="https://ivanhoe.io/terms" target="_blank">the terms of service of Ivanhoe</a>. The mandate to create a subscription via {{ selectedPaymentMethod.name }} is made via this first payment.
                                            </d-checkbox>
                                        </d-col>
                                    </d-card-body>
                                </d-card>
                            </div>
                        </d-form>
                    </d-card-body>
                    <d-card-footer class="border-top d-flex justify-content-end">
                        <d-link tag="button" class="btn btn-secondary" :to="{ name: 'billing-address' }">Back</d-link>
                        <d-button
                            @click="setBilling"
                            type="button"
                            class="btn ml-3 btn-success"
                            :disabled="selectedPaymentMethod && !confirm"
                        >
                            Submit
                        </d-button>
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import { BillingService } from '@/main';
import notification from '@/mixins/notification';

export default {
    mixins: [notification],

    data() {
        return {
            paymentMethods: [],
            percent: 100,
            selectedBillingUpgrade: '',
            selectedPaymentMethod: null,
            confirm: false,
        };
    },
    methods: {
        async getPaymentMethods() {
            if (this.$store.getters.getBillingInfo.planId) {
                this.paymentMethods = await BillingService.getPaymentMethods()
            } else {
                this.$router.push('/billing')
            }
        },

        async setBilling() {
            if (this.selectedPaymentMethod) {
                this.$store.commit('setPlanMethod', this.selectedPaymentMethod.provider_method)
                this.$store.commit('setPlanApplying', this.selectedBillingUpgrade)
                const paymentUrl = await BillingService.set()
                if(paymentUrl) {
                    window.location.replace(paymentUrl)
                } else {
                    this.showNotification('success', 'Alert', 'Billing plan successfully upgraded!')
                    this.$router.push('/')
                }
            } else {
                this.showNotification('warn', 'We have a problem', 'Choose payment method to continue')
            }
        }
    },

    computed: {
        billingInfo () {
            if (this.$store.getters.getBillingInfo.planId) {
                return this.$store.getters.getBillingInfo
            }
        }
    },

    created() {
        this.getPaymentMethods()
    },
};
</script>
